import React, {useState} from 'react';
import Button from '../form/button/button';
import {Collapse} from 'react-bootstrap';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
const CustomCollapse = ({btnText, children}) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="card " style={{padding: '4px'}}>

      {/* <div onClick={() => setOpen(!open)}>{btnComponent}</div> */}
         <Button clickHandler={() => setOpen(!open)}  styles={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"1rem"}} fullWidth  variant="submit-button">
           {btnText}
           {open?<ArrowDropUpIcon/>:<ArrowDropDownIcon/>}
         </Button>
      <Collapse in={open}>
        <div id="example-collapse-text" className="mt-3">
          <div className="card-body">{children}</div>
        </div>
      </Collapse>
    </div>
  );
};

export default CustomCollapse;
